import { useContext, useCallback } from "react";
import { AppContext } from "@/providers/AppContextProvider";
import { useQueryClient } from "@tanstack/react-query";
import { UsersService } from "@/services";

export const useSocialCoachSession = () => {
  const { session, refreshSession, clearSession } = useContext(AppContext);
  const queryClient = useQueryClient();

  const logout = useCallback(async () => {
    try {
      await UsersService.logout();
    } catch (e) {
      console.warn("Logout API failed:", e);
    } finally {
      clearSession(true);
      queryClient.removeQueries();
      queryClient.clear();
      queryClient.setQueryData(["session"], undefined);
    }
  }, [clearSession, queryClient]);

  return {
    session,
    refreshSession,
    clearSession,
    logout,
    userId: session?.userId,
    fullName: session?.fullName,
    playerId: session?.playerId,
    coachId: session?.coachId,
    isCoach: ["COACH", "ASSISTANT_COACH"].includes(session?.userRole || ""),
    isPlayer: session?.userRole === "PLAYER",
    isAssistantCoach: session?.userRole === "ASSISTANT_COACH",
    isMainCoach: session?.userRole === "COACH",
    isAdmin: session?.userRole === "ADMIN",
    isEditor: session?.userRole === "EDITOR",
    canManageVideoProjectQueue: session?.userRole === "ADMIN" || session?.userRole === "EDITOR",
    isImpersonating: !!session?.actor,
    canUseSlackMfa: !!session?.mfaMethods?.includes("slack"),
    hasPasskey: !!session?.mfaMethods?.includes("passkey"),
    supportEmail: session?.supportEmail || "support@socialcoach.io",
  };
};
